(function () {
  var timers = new Map();
  function initialize() {
    timers.forEach(function (timer, el) { if (!el.isConnected) { clearInterval(timer); timers.delete(el); } });
    document.querySelectorAll('[data-announcement-carousel]').forEach(function (el) {
      if (timers.has(el)) return;
      var slides = Array.from(el.querySelectorAll('[data-announcement-slide]'));
      if (slides.length < 2) return;
      var index = 0;
      var paused = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function show() { slides.forEach(function (slide, i) { slide.hidden = i !== index; }); }
      var controls = document.createElement('div');
      controls.className = 'announcement-controls';
      function button(label, content, action) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', label); b.textContent = content; b.addEventListener('click', action); controls.appendChild(b); return b; }
      button('Previous announcement', '‹', function () { index = (index + slides.length - 1) % slides.length; show(); });
      var pause = button('Pause announcements', 'Ⅱ', function () { paused = !paused; pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements'); });
      button('Next announcement', '›', function () { index = (index + 1) % slides.length; show(); });
      el.appendChild(controls);
      show();
      timers.set(el, setInterval(function () { if (!paused && !reducedMotion.matches && !document.hidden && !el.matches(':hover') && !el.contains(document.activeElement)) { index = (index + 1) % slides.length; show(); } }, 4500));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) { timers.forEach(function (timer, el) { if (event.target.contains(el)) { clearInterval(timer); timers.delete(el); } }); });
})();
